import apiClient from './axiosConfig';
import { API_URL } from '../config/api';

// Generic API call wrapper that handles token validation
export const makeApiCall = async (method, endpoint, data = null) => {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('No authentication token found');
  }
  
  const config = {
    method,
    url: `${API_URL}${endpoint}`,
  };
  
  if (data) {
    config.data = data;
  }
  
  return apiClient(config);
};

// Specific API helpers
export const apiGet = (endpoint) => makeApiCall('get', endpoint);
export const apiPost = (endpoint, data) => makeApiCall('post', endpoint, data);
export const apiPut = (endpoint, data) => makeApiCall('put', endpoint, data);
export const apiDelete = (endpoint) => makeApiCall('delete', endpoint);